import { useMutation } from '@tanstack/react-query';
import { usePluginApiClient } from '@/entities/plugin';

// Starts the Slack OAuth flow: POST /connect for an authorize URL, then
// hand the browser off to Slack. The redirect leaves the SPA, so there is
// no success state to render — Slack returns the user via ?slack=...
export function useConnectSlack() {
  const client = usePluginApiClient();

  const mutation = useMutation({
    mutationFn: async () => {
      const { authorizeUrl } = await client.connectSlack();
      window.location.href = authorizeUrl;
    },
  });

  return {
    connectSlack: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
